export const GET_PRODUCT_PAYMENT_STATUS_API = '/payments/payment/last/:id';

// Queries
export const QUERY_PRODUCT_PAYMENT_STATUS = 'QUERY_PRODUCT_PAYMENT_STATUS';
